import React from 'react';
import { useTranslation } from 'react-i18next';

import EnergyRevenueOverlayChart from '../station-comparison/EnergyRevenueOverlayChart';
// import SessionCountPerStationChart from '../station-comparison/SessionCountPerStationChart';
import StationComparisonList from '../station-comparison/StationComparisonList';
import UptimeTrendOverTimeChart from '../station-comparison/UptimeTrendOverTimeChart';

/**
 * Station Comparison
 * @returns {any} The rendered component
 */
function StationComparison() {
  const { t, i18n } = useTranslation('sidePanel');

  return (
    <div className="station-comparison-main" dir={i18n.dir()}>
      <StationComparisonList />
      <p className="graph-view">{t('graphView')}</p>
      <div className="station-comparison-chart">
        <EnergyRevenueOverlayChart />
        {/* <SessionCountPerStationChart /> */}
        <UptimeTrendOverTimeChart />
      </div>
    </div>
  );
}

export default StationComparison;
